<template>
    <div :class="`summary-bar ${this.rootClass}${this.flyoutOpen ? ` --active` : ''}`"
         tabindex="0"
         @click="$emit('click')"
         @keyup.enter="$emit('click')"
         @keyup.esc="$emit('click')">
        <div :class="`summary-bar__definition ${this.rootClass}__definition`">
            <i v-if="icon"
               :class="`summary-bar__definition__icon ${this.rootClass}__definition__icon ${this.icon}${this.flyoutOpen ? ` --active` : ''}`" />
            <span v-if="text"
                  :class="`summary-bar__definition__text ${this.rootClass}__definition__text${this.flyoutOpen ? ` --active` : ''}`">{{ text }}</span>
        </div>
        <div :class="`summary-bar__arrow-indicator ${this.rootClass}__arrow-indicator${this.flyoutOpen ? ' --hidden' : ''}`">
            <i :class="`summary-bar__arrow-indicator__icon ${this.rootClass}__arrow-indicator__icon fas fa-chevron-down`" />
        </div>
        <slot />
    </div>
</template>

<script>

export default {

    props: {
        flyoutOpen: {
            type: Boolean,
            required: true,
        },
        icon: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: '',
        },
        rootClass: {
            type: String,
            required: true,
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_summary-bar.scss

.summary-bar {
    font-size: 1.3rem;
    padding: rem(7px);
    position: relative;

    @include element('definition') {
        position: absolute;
        top: rem(3px);
        z-index: z-index('raised');
        width: 25%;
        display: inline-block;
        white-space: nowrap;

        > * {
            display: inline-block;
        }

        @include element('icon') {
            position: relative;
            top: rem(3px);
            padding-right: 0.5rem;
        }

        @include element('text') {
            font-size: 1rem;
        }
    }

    @include element('arrow-indicator') {
        position: absolute;
        bottom: rem(-12px);
        border-radius: 15rem;
        padding-bottom: rem(4px);
        font-size: 1rem;

        @include element('icon') {
            position: relative;
            bottom: -8px;
        }

        &.--hidden {
            display: none;
        }
    }
}

</style>
